const EUR = "EUR";

const setValueInRangeAndStep = function (value: number, step: number, min: number, max: number) {
    value = Math.round(value / step) * step;

    if (value <= min) {
        value = min;
    } else if (value >= max) {
        value = max;
    }

    return value;
}

const abrundenAufGanzzahl = function (value: number, step: number) {
    return Math.floor(value / step) * step;
}

const aufrundenAufGanzzahl = function (value: number, step: number) {
    return Math.ceil(value / step) * step;
}

export {EUR, setValueInRangeAndStep, abrundenAufGanzzahl, aufrundenAufGanzzahl}
